<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { Photo } from '@storefront/resources';

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: { type: String },
    headerType: { type: String },
    content: { type: String },
    photos: { type: Array as PropType<Photo[]>, required: true },
  });
</script>
<template>
  <SfSection :title="header" :headerType>
    <QuillContent v-if="content" :content />
    <div class="mosaic__images" v-if="photos.length > 0">
      <MediaPicture :photo="photos" photoable="Section" type="mosaic" sizes="453x400 2x max 576, 226x200 max 576, 884x664 2x max 992, 442x332 max 992, 1304x987 2x, 652x489"  />
    </div>
  </SfSection>
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  :root {
    --sf-mosaic-images-padding: 0;
    --sf-mosaic-images-gap: 2rem;

    @include media.query(lg) {
      --sf-mosaic-gap: 1rem;
      --sf-mosaic-images-padding: 0 1rem;
      --sf-mosaic-images-gap: 0.75rem;
    }
  }

  .mosaic__images {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--sf-mosaic-images-gap);
    padding: var(--sf-mosaic-images-padding);

    img {
      aspect-ratio: 4 / 3;
      max-width: 100%;
      object-fit: contain;
      object-position: center;
    }
  }
</style>
